import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store.js'
import './registerServiceWorker'
import VueDjangoWs from './vue-django-ws.js'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
import FlagIcon from 'vue-flag-icon'
import filters from '@/filters'
import vSelect from 'vue-select'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(VueDjangoWs)
Vue.use(FlagIcon);
Vue.component('v-select', vSelect)


/*Vue.use(VueNativeSock, settings.websocketUrl,{
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000,
    format: 'json',
    passToStoreHandler: function(eventName, event){
        console.log(eventName, event)
    }
})*/


Vue.http.interceptors.push(function (request) {
    //console.log('interecptor', Vue.cookie.get('csrftoken'), request)
    if (['POST', 'PUT'].indexOf(request.method) >= 0) {
        request.headers.set('X-CSRFToken', Vue.cookie.get('csrftoken'));
    }
})

Vue.http.options.xhr = {credentials: true}
Vue.http.options.credentials = true;
Vue.http.options.emulateJSON = true

for (var key in filters.filters) {
    var val = filters.filters[key];
    Vue.filter(key, val);
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
